"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.GameOverScreenInterface = exports.EVENTS = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /** @module GameOverScreen **/


var _Dispatcher = require("./Dispatcher");

var _Dispatcher2 = _interopRequireDefault(_Dispatcher);

var _utils = require("./utils");

var _eventsjs = require("@pch/eventsjs");

var _eventsjs2 = _interopRequireDefault(_eventsjs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var EVENTS = {
    /** @event GameOverScreen#open **/
    OPEN: 'gosOpen',
    /** @event GameOverScreen#close **/
    CLOSE: 'gosClose',
    /** @event GameOverScreen#continue **/
    CONTINUE: 'gosContinue', // for gold user continue click
    /** @event GameOverScreen#forfeit **/
    FORFEIT: 'gosForfeit',
    /** @event GameOverScreen#createPass **/
    CREATE_PASS: 'gosCreatePass', // for silver user continue click
    /** @event GameOverScreen#createPassSuccess **/
    CREATE_PASS_SUCCESS: 'gosCreatePassSuccess' // should be fired after SSO call
};

var CONTINUE_BTN_SHOW_CLASS = 'gos__continue-btn--show';
var CLAIM_BTN_SHOW_CLASS = 'gos__claim-btn--show';
var GOS_SHOW_CLASS = "gos--show";
var GOS_CLOSE_CLASS = "gos--close";
var CASH_WIN_CLASS = "gos--cash-win";
var TOKEN_WIN_CLASS = "gos--token-win";
var WIN_SHOW_CLASS = "gos__win--show";
var REG_CLASS = "gos--signedin";
var FULL_REG_CLASS = "gos--fullreg";
var TD_ERROR_CLASS = 'td';
var PATH_FINISHED_CLASS = "gos--path-finished";
var PATH_COMPLETED_CLASS = "gos--path-completed";

/** @constant {string} **/
var PATH_FINISHED = "finished";
/** @constant {string} **/
var PATH_COMPLETED = "completed";

/**
* Interface for GameOverScreen classes. 
* GameManager knows how to handle instances of GameOverScreenInterface, pass your implementation to its constructor
*
* @interface 
*
* @example
* class MyGameOverScreen extends GameOverScreenInterface {
*   // ... interface implentation
* }
* // later...
* // GameManager will call your reset/setup/open, etc, methods automatically for you when appropriate
* var gm = new GameManager({
*   gos: new MyGameOverScreen()
* });
*/

var GameOverScreenInterface = function () {
    function GameOverScreenInterface() {
        _classCallCheck(this, GameOverScreenInterface);
    }

    _createClass(GameOverScreenInterface, [{
        key: "reset",

        /**
        * Reset the screen state
        */
        value: function reset() {}
        /**
        * Setup the screen with the game response
        * @param {GameServiceError} [errResponse]
        * @param {GameServiceResponse} [serviceResponse]
        */

    }, {
        key: "setup",
        value: function setup(errResponse, serviceResponse) {}
        /**
        * Show the screen
        * @fires GameOverScreen#open
        */

    }, {
        key: "open",
        value: function open() {}
        /**
        * Set the screen to auto claim mode
        * @param {bool}
        */

    }, {
        key: "setAutoClaim",
        value: function setAutoClaim(isAutoClaim) {}
        /**
        * Set the path status on the screen
        * @param {string} one of the PATH_COMPLETE or PATH_FINISHED constants
        */

    }, {
        key: "setPathStatus",
        value: function setPathStatus(status) {}
    }]);

    return GameOverScreenInterface;
}();

var GameOverScreen = function (_GameOverScreenInterf) {
    _inherits(GameOverScreen, _GameOverScreenInterf);

    /**
    * @class
    * @implements {module:GameOverScreen~GameOverScreenInterface}
    * @classdesc
    *
    * The GameOverScreen class handles injecting responses and win amounts into markup that represents a game over screen for the game.
    * The dist/gos.html an be pulled into your page unchaged or modified as long as you provide elements with the same class names. 
    * The dist/gos.css provide stylesheet provides some base styles for hiding/showing the elements as necessary, and you should style the rest as needed.  
    *
    * If the packaged html/css does not suit your needs, you can implement your own GameOverScreen, simply extend from this GameOverScreen class,
    * override and  implement the methods to your needs, and inject it to the game manager upon instantiation.  
    * The most important methods you will likely be concerned with are, setup, and open
    *
    * @example
    *   class MyGameOverScreen extends GameOverScreen {
    *
    *       // Setup is called by the game manager for you once the start response is returned for the game
    *       // It receives the error response (if failed), or the start response. You can update your game over
    *       // screen html now with the start response win values, or store them for later, however you want 
    *       // to implement your own screen
    *       setup(errResponse, startResponse) {
    *       }
    *       // Open is called by the game manager for you on game end when the game over screen should be shown
    *       open() {
    *       }
    *   }
    *   // ... later
    *   // pass our GOS instance to the manager for handling game over
    *   var gm = new GameManager(gameJson, {
    *      gos: new MyGameOverScreen()
    *   });
    *
    * @mixes external:EventsMixin
    *
    * @param {object} opts
    *   @param {HTMLElement} opts.rootNode - root element of the gos markup. You can leave this empty and call mount() later
    *   @param {object} opts.user - PCHUSER data, if provided, will add additional classname hooks to the root, and update gos__p13n__name element with user's name
    *   @param {PathDispatcher} [opts.dispatcher]
    *   @param {bool} opts.userNeedsPassword - True if user needs to create password on continue
    *   @param {string} opts.animInClass - Optional class to add to the root element when showing the screen, in addition a default class is added
    *   @param {string} opts.animOutClass - Optional class to add to the root element when closing the screen, otherwise a default class is added
    *   @param {object} opts.errorMessages - messages for each element when an error is returned
    *   @param {object} opts.winMessages - messages for each element when a win is returned
    */
    function GameOverScreen(opts) {
        _classCallCheck(this, GameOverScreen);

        var _this = _possibleConstructorReturn(this, (GameOverScreen.__proto__ || Object.getPrototypeOf(GameOverScreen)).call(this, opts));

        _this.opts = Object.assign({
            errorMessages: {
                top: 'We are experiencing technical difficulties',
                main: '',
                youScored: "",
                bottom: 'We are sorry for this inconvenience. Please try again!'
            },
            winMessages: {
                top: "",
                main: "",
                youScored: "You Scored",
                bottom: ""
            }
        }, opts || {});
        if (opts.rootNode) {
            _this.mount(opts.rootNode);
        }
        /** @member {Dispatcher} **/
        _this.dispatcher = opts.dispatcher || _Dispatcher2.default;
        _this._autoClaim = false;
        (0, _utils.objectAssign)(_this, _eventsjs2.default);
        _this.EVENTS = (0, _utils.objectAssign)({}, EVENTS);
        return _this;
    }

    /**
    * Mounts to the page, modifying DOM, adding listeners, etc
    *
    * @param {HTMLElement}
    */


    _createClass(GameOverScreen, [{
        key: "mount",
        value: function mount(rootNode) {
            this.rootNode = rootNode;
            this.elements = {
                gos: this.rootNode.querySelector(".gos") || this.rootNode,
                p13n_name: this.rootNode.querySelector(".gos__p13n__name"),
                top_msg: this.rootNode.querySelector('.gos__top-text'),
                main_msg: this.rootNode.querySelector('.gos__main-text'),
                you_won: this.rootNode.querySelector('.gos__you-won'),
                bottom_msg: this.rootNode.querySelector('.gos__bottom-text'),
                claim_btn: this.rootNode.querySelector('.gos__claim-btn'),
                continue_btn: this.rootNode.querySelector('.gos__continue-btn'),
                nothanks_text: this.rootNode.querySelector('.gos__forfeit'),
                inputsContainer: this.rootNode.querySelector('.gos__sso-inputs-container'),
                claimCode: this.rootNode.querySelector('.gos__claim-code'),
                password: this.rootNode.querySelector('#gos_pass'),
                confirmPassword: this.rootNode.querySelector('#gos_confirmpass'),
                persist: this.rootNode.querySelector('#gos_persist')
            };
            if (this.opts.user) {
                if (this.opts.user.gmt) {
                    this.elements.gos.classList.add("gos--signedin");
                    if (this.elements.p13n_name) {
                        this.elements.p13n_name.innerText = this.opts.user.firstName || this.opts.user.email;
                    }
                }
                if (this.opts.user.isFullyRegistered) {
                    this.elements.gos.classList.add("gos--fullreg");
                }
            }
        }

        /**
        * Open claim window
        *
        * @param {string}
        */

    }, {
        key: "openClaim",
        value: function openClaim(url) {
            var w = 400,
                h = 400;
            var popwin = window.open(url, "win", "scrollbars=yes,toolbar=no,directories=no,menubar=no,resizable=yes,status=no,width=" + w + ",height=" + h + "");
            popwin.window.focus();
        }

        /**
        * Set the screen to auto claim mode
        *
        * @param {bool}
        */

    }, {
        key: "setAutoClaim",
        value: function setAutoClaim(val) {
            this._autoClaim = val;
            if (this._autoClaim) {
                this.showContinueButton();
            } else {
                this.showClaimButton();
            }
        }

        /**
        * Set the path status on the screen
        *
        * @param {string} one of the PATH_COMPLETE or PATH_FINISHED constants
        */

    }, {
        key: "setPathStatus",
        value: function setPathStatus(status) {
            this.elements.gos.classList.remove(PATH_FINISHED_CLASS);
            this.elements.gos.classList.remove(PATH_COMPLETED_CLASS);
            if (status) {
                switch (status) {
                    case PATH_COMPLETED:
                        this.elements.gos.classList.add(PATH_COMPLETED_CLASS);
                        break;
                    case PATH_FINISHED:
                        this.elements.gos.classList.add(PATH_FINISHED_CLASS);
                        break;
                }
            }
        }

        /**
        * dispatch an event
        *
        * @param {string} eventName
        */

    }, {
        key: "dispatchEvent",
        value: function dispatchEvent(eventName) {
            if (this.dispatcher) {
                this.dispatcher.dispatch(eventName);
            }
            this.fireEvent(eventName);
        }

        /**
        * Display the claim button
        */

    }, {
        key: "showClaimButton",
        value: function showClaimButton() {
            this.elements.continue_btn.classList.remove(CONTINUE_BTN_SHOW_CLASS);
            this.elements.claim_btn.classList.add(CLAIM_BTN_SHOW_CLASS);
        }

        /**
        * Display the continue button
        */

    }, {
        key: "showContinueButton",
        value: function showContinueButton() {
            this.elements.continue_btn.classList.add(CONTINUE_BTN_SHOW_CLASS);
            this.elements.claim_btn.classList.remove(CLAIM_BTN_SHOW_CLASS);
        }

        /**
        * Show the screen
        *
        * @fires GameOverScreen#open
        */

    }, {
        key: "open",
        value: function open() {
            this.elements.gos.classList.add(GOS_SHOW_CLASS);
            if (this.opts.animInClass) {
                this.elements.gos.classList.add(this.opts.animInClass);
            }

            this.dispatchEvent(EVENTS.OPEN);
        }

        /**
        * Hide the screen
        *
        * @fires GameOverScreen#close
        */

    }, {
        key: "close",
        value: function close() {
            if (this.opts.animOutClass) {
                this.elements.gos.classList.add(this.opts.animOutClass);
            } else {
                this.elements.gos.classList.remove(GOS_SHOW_CLASS);
                this.elements.gos.classList.add(GOS_CLOSE_CLASS);
            }

            this.dispatchEvent(EVENTS.CLOSE);
        }

        /**
        * Reset the screen state
        */

    }, {
        key: "reset",
        value: function reset() {
            this.elements.gos.classList.remove(GOS_SHOW_CLASS);
            this.elements.gos.classList.remove(GOS_CLOSE_CLASS);
            this.elements.gos.classList.remove(TD_ERROR_CLASS);
            this.elements.gos.classList.remove(CASH_WIN_CLASS);
            this.elements.gos.classList.remove(TOKEN_WIN_CLASS);
            this.elements.gos.classList.remove(PATH_FINISHED_CLASS);
            this.elements.gos.classList.remove(PATH_COMPLETED_CLASS);
            if (this.opts.animOutClass) {
                this.elements.gos.classList.remove(this.opts.animOutClass);
            }

            this.showContinueButton();

            this.elements.top_msg.innerHTML = "";
            this.elements.main_msg.innerHTML = "";
            this.elements.you_won.innerText = "";
            this.elements.bottom_msg.innerHTML = "";
            this.elements.claimCode.innerText = "";

            var wins = this.rootNode.querySelectorAll("." + WIN_SHOW_CLASS);
            if (wins) {
                for (var i = 0; i < wins.length; i++) {
                    wins[i].classList.remove(WIN_SHOW_CLASS);
                    wins[i].querySelector(".gos__win__text").innerHTML = "";
                }
            }

            this.hasError = false;
        }

        /**
        * Setup the screen with the game response
        *
        * @param {GameServiceError} [errResponse]
        * @param {GameServiceResponse} [serviceResponse]
        */

    }, {
        key: "setup",
        value: function setup(errResponse, serviceResponse) {
            var gosClass = [],
                messages = {};

            if (errResponse) {
                gosClass.push(TD_ERROR_CLASS);
                messages = this.getErrorMessages(errResponse);
                this.hasError = true;
            } else {
                var cashWins = serviceResponse.isCashWinner() ? serviceResponse.getCashWins() : null;
                var tokenWins = serviceResponse.isTokenWinner() ? serviceResponse.getTokenWins() : null;
                if (!cashWins && !tokenWins) {
                    throw new Error('GOS must have prizeType information');
                }
                if (cashWins) {
                    gosClass.push(CASH_WIN_CLASS);
                }
                if (tokenWins) {
                    gosClass.push(TOKEN_WIN_CLASS);
                }
                messages = Object.assign({}, this.getWinMessages(serviceResponse));
                if (cashWins) {
                    var claimInfo = cashWins[0].claim_info;
                    if (claimInfo) {
                        messages.claimCode = claimInfo.code || "";
                        messages.claimUrl = claimInfo.form_url || "";
                        this.claimInfo = claimInfo;
                    }
                    this.hasCashWin = true;
                }

                if (cashWins && !this._autoClaim) {
                    this.showClaimButton();
                } else {
                    this.showContinueButton();
                }

                // apply each win message
                if (cashWins) {
                    cashWins.forEach(this.setupWin.bind(this));
                }
                if (tokenWins) {
                    tokenWins.forEach(this.setupWin.bind(this));
                }
            }

            for (var i = 0, n = gosClass.length; i < n; i++) {
                this.elements.gos.classList.add(gosClass[i]);
            }

            // apply messages
            this.elements.top_msg.innerHTML = messages.top || "";
            this.elements.main_msg.innerHTML = messages.main || "";
            this.elements.you_won.innerText = messages.youScored || "";
            this.elements.bottom_msg.innerHTML = messages.bottom || "";
            this.elements.claimCode.innerText = messages.claimCode || "";

            this.elements.claim_btn.addEventListener('click', this.onClaimClick.bind(this), false);
            this.elements.continue_btn.addEventListener('click', this.onContinueClick.bind(this), false);
            this.elements.nothanks_text.addEventListener('click', this.onForfeitClick.bind(this), false);

            if (errResponse) {
                this.open();
            }
        }

        /**
        * Returns error messages
        *
        * @returns {string[]}
        */

    }, {
        key: "getErrorMessages",
        value: function getErrorMessages(errResponse) {
            return this.opts.errorMessages;
        }

        /**
        * Returns win messages
        * @returns {string[]}
        */

    }, {
        key: "getWinMessages",
        value: function getWinMessages(serviceResponse) {
            return this.opts.winMessages;
        }

        /**
        * Sets up the win display
        * @param {object} win - the win data
        */

    }, {
        key: "setupWin",
        value: function setupWin(win) {
            var winClass = win.type.toLowerCase();
            var winNode = this.rootNode.querySelector(".gos__win--" + winClass);
            winNode.querySelector(".gos__win__text").innerHTML = this.getWinHTML(win);
            winNode.classList.add(WIN_SHOW_CLASS);
        }

        /**
        * Returns html markup for the given win to display
        * @param {object} win - the win data
        */

    }, {
        key: "getWinHTML",
        value: function getWinHTML(win) {
            return win.description;
        }

        /**
        * Click handler for the forfeit button
        * @fires GameOverScreen#forfeit
        */

    }, {
        key: "onForfeitClick",
        value: function onForfeitClick(ev) {
            this.dispatchEvent(EVENTS.FORFEIT);
        }

        /**
        * Click handler for the claim button
        * @fires GameOverScreen#continue
        */

    }, {
        key: "onClaimClick",
        value: function onClaimClick(ev) {
            ev.preventDefault();
            if (this.dispatchPassword()) {
                return;
            }
            this.openClaim(this.claimInfo.form_url);
            this.dispatchEvent(EVENTS.CONTINUE);
        }

        /**
        * Click handler for the continue button
        * @fires GameOverScreen#continue
        */

    }, {
        key: "onContinueClick",
        value: function onContinueClick(ev) {
            ev.preventDefault();
            if (this.dispatchPassword()) {
                return;
            }
            this.dispatchEvent(EVENTS.CONTINUE);
        }

        /**
        * returns password field HTML element
        * @returns {HTMLElement}
        */

    }, {
        key: "getPasswordElement",
        value: function getPasswordElement() {
            return this.elements.password;
        }

        /**
        * Returns confirm pass field html element
        * @returns {HTMLElement}
        */

    }, {
        key: "getConfirmPasswordElement",
        value: function getConfirmPasswordElement() {
            return this.elements.confirmPassword;
        }

        /**
        * Returns persist field html element
        * @returns {HTMLElement}
        */

    }, {
        key: "getPersistElement",
        value: function getPersistElement() {
            return this.elements.persist;
        }

        /**
        * @fires GameOverScreen#createPass
        */

    }, {
        key: "dispatchPassword",
        value: function dispatchPassword() {
            if (this.opts.userNeedsPassword && (this.hasError || !this.hasCashWin)) {
                this.dispatchEvent(EVENTS.CREATE_PASS, this.elements.inputsContainer, this.elements.password, this.elements.confirmPassword, this.elements.persist && this.elements.persist.checked);
                return true;
            }
            return false;
        }
    }]);

    return GameOverScreen;
}(GameOverScreenInterface);

exports.EVENTS = EVENTS;
exports.GameOverScreenInterface = GameOverScreenInterface;
exports.default = GameOverScreen;